(() => {
  const refreshRegionalHero = () => {
    const controller = window.SNFRegionalExperience;
    if (!controller?.getState || !controller?.resolveProvince) return;
    const state = controller.getState();
    controller.resolveProvince(state.province || '');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshRegionalHero, { once: true });
  } else {
    refreshRegionalHero();
  }

  window.addEventListener('shopify:section:load', refreshRegionalHero);
})();
